<template>
  <div>
    <div class="mr-2 mt-1">
      <div class="row">
        <div class="col-md-12 col-12">
          <div  class=" d-flex flex-row-reverse">
            <p class="text-primary"><strong>Total Records : </strong><span class="text-success">{{totalNumberOfRecords}}</span></p>
          </div>
        </div>
        <div class="col-md-12 col-12">
          <div v-if="typeof (showPerPage) != 'undefined'" class=" d-flex flex-row-reverse">
            <div class="form-group">
              <label class="form-label" for="user-role">Per Page</label>
              <select id="user-role" v-model="tempPerPage" class="form-control">
                <option value="10" selected>10</option>
<!--                <option v-show="parseInt(totalNumberOfRecords) > 10" value="20">20</option>-->
                <option  value="30">30</option>
                <option  value="50">50</option>
                <option  value="100">100</option>
                <option  value="200">200</option>
                <option  value="250">250</option>
<!--                <option v-show="parseInt(totalNumberOfRecords) > 300" value="400">400</option>-->
<!--                <option v-show="parseInt(totalNumberOfRecords) > 400" value="500">500</option>-->
<!--&lt;!&ndash;                <option v-show="parseInt(totalNumberOfRecords) > 0" :value="parseInt(totalNumberOfRecords)">All</option>&ndash;&gt;-->
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mr-2 mt-1" v-if="typeof(exportData) != 'undefined'">
      <div class="row">
        <div class="col-md-12 col-12">
          <div  class=" d-flex flex-row-reverse">
            <div class="mb-1">
              <button  type="button" class="btn-sm btn btn-gradient-success mr-1" @click="exportData.cta('excel')">
                <!--                <div v-show="excelLoader"  class="spinner-border text-white spinner-border-sm mr-1"></div>-->
                <feather type="file-text"></feather>
                Export Excel
              </button>
              <button  type="button" class="btn-sm btn btn-gradient-danger" @click="exportData.cta('pdf')">
                <!--                <div v-show="pdfLoader" class="spinner-border text-white spinner-border-sm mr-1"></div>-->
                <feather type="file-text"></feather
                >
                Export PDf
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-datatable table-responsive pt-0">
      <table class="user-list-table table">
        <thead class="thead-light">
        <tr>
          <th v-if="typeof(tableAccordian) != 'undefined'"></th>
          <th v-if="typeof(loadMore) == 'undefined'">S.No</th>
          <th v-for="(header, headerKey) in tableHeaderValues" :key="headerKey" style="min-width: 140px;">
            {{ header.title }}
          </th>
          <th
              v-if="
              typeof actions != 'undefined' &&
                (actions.length || tableDeleteToggle.length)
            "
          >
            Actions
          </th>
        </tr>
        </thead>
        <pulse-loader
            :loading="loading"
            color="#2a709a"
            class="table-loader"
        ></pulse-loader>
        <tbody>
        <tr v-if="!list.length">
          <td
              :colspan="
              actions.length
                ? tableHeaderValues.length + 1
                : tableHeaderValues.length
            "
              class="font-weight-bolder font-medium-2"
              style="text-align: center"
          >
            No data available
          </td>
        </tr>
        <template  v-for="(row, index) in list">
          <tr>
            <!--          <td>{{ count + (index + 1) }}</td>-->
            <td v-if="typeof(tableAccordian) != 'undefined'">
              <button type="button" v-if="resolveAccordianConditionalRendering(row)" class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light" data-toggle="collapse"  :data-target="'#demo'+index" @click="accordionToShow  = index">
                +
              </button>
            </td>
            <td v-if="typeof(loadMore) == 'undefined'">{{ count + (index + 1) }}</td>
            <td v-for="(value, valueKey) in tableHeaderValues" :key="valueKey">
            <span
                :class="typeof(value.customClass) == 'undefined'? 'd-flex' : value.customClass "
                v-if="typeof value.html != 'undefined'"
                @click="resolveTDClick(value,row,index)"
                v-html="resolve(value, row)"
            ></span>
              <span v-else>{{ resolve(value, row) }}</span>
            </td>
            <td
                v-if="tableButtons.length || tableDeleteToggle.length"
                class="d-flex"
            >
              <template v-for="(btn, btnKey) in tableButtons[index]">
                <Button

                    v-if="btn.conditionalRendering !== true"
                    :class="resolveBtnClass(btn, btnKey)"
                    v-b-modal.modal-center
                    @click="btn.cta(row, index, btnKey)"
                    class="btn btn-sm"
                    :loading="btn.loading"
                >
                  {{ btn.title }}
                </Button>
              </template>
              <template v-for="(btn, btnKey) in tableButtons[index]">
                <Button :key="btnKey"
                        v-if="
                  typeof btn.conditionalRendering == 'undefined'
                    ? btn.conditionalRendering
                    : btn.condition(row, index, btnKey)
                "
                        :class="resolveBtnClass(btn, btnKey)"
                        v-b-modal.modal-center
                        @click="btn.cta(row, index, btnKey)"
                        class="btn btn-sm"
                        :loading="btn.loading"
                >
                  {{ btn.title }}
                </Button>
              </template>
              <template v-if="typeof tableDeleteToggle != 'undefined'">
                <template v-if="tableDeleteToggle.length">
                  <template class="d-flex">
                    <!--                    <b-form-checkbox-->
                    <!--                        v-for="(btn, btnKey) in tableDeleteToggle[index]"-->
                    <!--                        :key="btnKey + 3"-->

                    <!--                        :class="-->
                    <!--                      typeof btn.class != 'undefined'-->
                    <!--                        ? btn.class-->
                    <!--                        : 'ml-1 custom-control-primary'-->
                    <!--                    "-->
                    <!--                        :value="1"-->
                    <!--                        :checked="row.status"-->
                    <!--                        @change="onSwitch(btn, row, index, btnKey)"-->
                    <!--                        switch-->
                    <!--                        inline-->
                    <!--                    >-->
                    <!--                    </b-form-checkbox>-->


                    <div class="custom-control custom-control-success custom-switch ml-1"     v-for="(btn, btnKey) in tableDeleteToggle[index]"
                         :key="btnKey + 3">
                      <input type="checkbox"   :checked="row.status" class="custom-control-input" :id="index"  @change="onSwitch(btn, row, index, btnKey)" >
                      <label class="custom-control-label" :for="index" :ref="'cus_'+index"></label>
                    </div>

                  </template>
                </template>
              </template>
              <template></template>
            </td>
          </tr>
          <tr v-if="typeof(tableAccordian) != 'undefined'">
            <td :colspan="resolveAccordianCollspanLength(actions,tableHeaderValues)" class="hiddenRow ">
              <div class="collapse" :id="'demo'+index">
                <div class="card-body">
                  <div class="card">
                    <div class="row pl-5 font-weight-bolder font-medium-2" v-if="!tableAccordian.body.getData(row, index).length">
                      No Data Avaliable
                    </div>
                    <table class="table border-dark  badge-glow" v-if="tableAccordian.body.getData(row, index).length">
                      <thead>
                      <tr>
                        <th v-for="(accordianHead,headIndex) in tableAccordian.header" :key="headIndex">{{accordianHead.title}}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(accordianBodyItem,accordianBodyIndex) in tableAccordian.body.getData(row, index)" :key="accordianBodyIndex" >
                        <td v-html="subBodyItem" v-for="subBodyItem in accordianBodyItem" ></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
<!--      <CommonPaginator-->
<!--          :externalTotalRecord="externalTotalRecord"-->
<!--          :storageKey="storageKey"-->
<!--          :url="requestUrl"-->
<!--          :data="data"-->
<!--          :bodyData="bodyData"-->
<!--          @getRecords="getRecords"-->
<!--          :defaultLimit="perPage"-->
<!--          :force="internalForce"-->
<!--          @pageChanged="pageChanged"-->
<!--          @hideLoader="hideLoader"-->
<!--          :loadMore="loadMore"-->
<!--      />-->
      <div
          class="row w-100 my-lg-3 justify-content-center"
          v-if="pagination.total > 0 && pagination.perPage < pagination.total"
      >
        <button
            v-if="(currentPage*perPage < totalRecords) && !hideLoadMore"
            @click="loadMoreRecords"
            class="btn btn-primary mr-1 d-flex"
            :disabled="loadmoreLoader"
        >
          <span v-if="loadmoreLoader" class="spinner-grow spinner-grow-sm mr-1" role="status" aria-hidden="true"></span>
          Load More
        </button>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirm" message="Are you sure to change the status?"
                       title="Change Status"
                       @hide="denied"></ConfirmationModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: [
    "url",
    "tableHeaderValues",
    "actions",
    "data",
    "deleteActions",
    "mutedData",
    "filteredData",
    "storageKey",
    "externalTotalRecord",
    "loadMore",
    'showPerPage',
    'tableAccordian',
    'forceShowActionHeader',
    'showOnlyAccordian',
    'accordianCondition',
    'forceStartPerPageForPagination',
    'exportData',
    'force',
    'alterResponseData',
  ],
  data() {
    return {
      list: [],
      // force: false,
      internalForce: false,
      count: 0,
      tableButtons: [],
      tableDeleteToggle: [],
      loading: true,
      status: "",
      perPage: 10,
      tempPerPage: 10,
      accordionToShow: -1,
      showConfirmationModal:false,
      currenctBtnData: null,
      totalNumberOfRecords:0,
      currentPage: 1,
      pagination: "",
      hideLoadMore: false,
      loadmoreLoader: false,

    };
  },
  mounted() {
    if(typeof(this.forceStartPerPageForPagination) != 'undefined'){
      this.perPage = parseInt(this.forceStartPerPageForPagination)
    }
    this.sendCall()
  },
  methods: {
    resolveBtnClass(btn,btnkey){
      if(typeof btn.class != 'undefined')
      {
        if(btnkey != 0){
          return btn.class+' ml-sm-50'
        }
        return btn.class
      } else{
        if(btnkey != 0){
          return 'btn-primary ml-sm-50'
        }
        return 'btn-primary'
      }
    },
    denied(){
      this.$refs['cus_'+this.currenctBtnData.index][0].click()
      let currentStatus =  this.currenctBtnData.row.status
      this.list[this.currenctBtnData.index].status = currentStatus
      this.showConfirmationModal = false
      this.currenctBtnData = null
    },
    confirm() {
      let currentStatus =  this.currenctBtnData.row.status
      this.currenctBtnData.row.status = !currentStatus
      this.currenctBtnData.btn.cta(this.currenctBtnData.row, this.currenctBtnData.index, this.currenctBtnData.btnKey)
      this.list[this.currenctBtnData.index].status = !currentStatus
      this.showConfirmationModal = false
      this.currenctBtnData = null
    },
    onSwitch(btn, row, index, btnKey) {
      if(typeof row.showConfirmationModal == "undefined") {
        this.currenctBtnData = {
          btn: btn,
          row: row,
          index: index,
          btnKey: btnKey
        }
        this.showConfirmationModal = true
      }
    },
    resolveTDClick(value,row,index){
      if(typeof(value.cta) != 'undefined'){
        return value.cta(row, index)
      }else{
        return null
      }

    },
    resolveAccordianConditionalRendering(row){
      let result = false
      if(typeof(this.tableAccordian) != 'undefined'){
        result = true
      }
      if(typeof(this.accordianCondition) != 'undefined'){
        result = this.accordianCondition.condition(row)
      }
      return result
    },
    resolveAccordianCollspanLength(actions,tableHeaderValues){
      if(actions.length){
        return tableHeaderValues.length +3
      }else{
        return tableHeaderValues.length+1
      }
    },
    hideLoader(value) {
      this.loading = value;
    },
    pageChanged(value) {
      this.loading = value;
    },
    sendCall(){
      this.loadmoreLoader = true
      let data = {};
      if (
          typeof this.filteredData != "undefined" &&
          this.filteredData != null &&
          Object.keys(this.filteredData).length > 0 &&
          this.filteredData != ""
      ) {
        // this.loading = true
        data = this.filteredData;
      }
      data.page = this.currentPage
      data.perPage = this.perPage
      this.makeRequest("post", this.url,data , {}, false).then(callResponse => {
        this.loadmoreLoader = false;
        this.loading = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            var response = callResponse.response.data.data;
            var result = {
              data: response.data ? response.data : response,
              noRecordFound: false,
              pagination: response.paginationData,
              fullResponse: response
            };
            if (response.paginationData) {
              this.currentPage = response.paginationData.currentPage;
            }
            this.getRecords(result)
            this.pagination = response.paginationData;
          } else if (code == 400) {
            this.hideLoader(false)
          }
        }
      });
    },
    loadMoreRecords() {
      let total = this.pagination.total;
      let perPage = this.pagination.perPage;
      let totalPages = parseInt(total / perPage) + 1;
      if (this.currentPage == totalPages) {
        this.hideLoadMore = true;
      } else {
        this.currentPage += 1;
        this.sendCall()
      }
    },
    getRecords(response) {
      if(typeof(this.alterResponseData) != 'undefined'){
        this.alterResponseData.alter(response)
      }

      this.$emit("getFullResponse", response);
      this.loading = false;
      for (let i = 0; i < response.data.length; i++) {
        this.list.push(response.data[i])
      }
      if (response.pagination) {
        this.totalNumberOfRecords = response.pagination.total
        var currentPage = response.pagination.currentPage;
        this.count = response.pagination.perPage * (currentPage - 1);
      }
      this.tableButtons = this.getCloneActions(this.list);
      this.tableDeleteToggle = this.getDeleteCloneActions(this.list);
    },
    resolve(data, obj) {
      var value = data.valueKey.split(".").reduce(function (prev, curr) {
        return prev ? prev[curr] : null;
      }, obj || self);
      if (typeof data.alter != "undefined") {
        return data.alter(value, obj);
      } else {
        return typeof value != "undefined" ? value : "-";
      }
    },
    getCloneActions(list) {
      var actions = [];
      if (this.actions.length > 0) {
        list.forEach(() => {
          var newActions = [];
          this.actions.forEach(obj => {
            var newObj = {};
            Object.assign(newObj, obj);
            newActions.push(newObj);
          });
          actions.push(newActions);
        });
      }
      return actions;
    },
    getDeleteCloneActions(list) {
      var actions = [];
      if (this.deleteActions) {
        if (this.deleteActions.length > 0) {
          list.forEach(() => {
            var newActions = [];
            this.deleteActions.forEach(obj => {
              var newObj = {};
              Object.assign(newObj, obj);
              newActions.push(newObj);
            });
            actions.push(newActions);
          });
        }
        return actions;
      }
    }
  },
  computed: {
    ...mapState(['excelLoader','pdfLoader']),
    requestUrl() {
      var url = "";
      url = this.url;
      return url;
    },
    // bodyData() {
    //   if (typeof (this.loadMore) != 'undefined') {
    //     this.list = []
    //   }
    //   let body = {};
    //   if (
    //       typeof this.filteredData != "undefined" &&
    //       this.filteredData != null &&
    //       Object.keys(this.filteredData).length > 0 &&
    //       this.filteredData != ""
    //   ) {
    //     // this.loading = true
    //     body = this.filteredData;
    //   }
    //   return body;
    // }
    totalRecords: {
      // getter
      get: function() {
        return this.pagination ? this.pagination.total : 0;
      },
      // setter
      set: function(newValue) {
        this.pagination.total = newValue;
      }
    },
  },
  watch: {
    mutedData(val) {
      if (typeof (val.pushRow) != 'undefined') {
        this.list.push(val.row)
        this.tableButtons = this.getCloneActions(this.list);
        this.tableDeleteToggle = this.getDeleteCloneActions(this.list);
      } else {
        for (let [key, value] of Object.entries(val)) {
          if (key == "index") {
            var index = value;
            continue;
          }
          if (key == "delete") {
            this.list.splice(val.index, 1);
            let storeData = this.$store.getters["get" + this.storageKey];
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (typeof storeData.firstPageData.data[index] != "undefined") {
                  if (storeData.firstPageData.data[index].id == value) {
                    storeData.firstPageData.data.splice(index, 1);
                    this.list = storeData.firstPageData.data;
                    if (typeof storeData.otherPageData == "undefined") {
                      // storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total - 1
                      // this.externalTotalRecord = storeData.firstPageData.pagination.total
                    }
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                // storeData.otherPageData.pagination.total = storeData.otherPageData.pagination.total - 1
                // storeData.firstPageData.pagination.total = storeData.firstPageData.pagination.total - 1

                if (typeof storeData.otherPageData.data[index] != "undefined") {
                  if (storeData.otherPageData.data[index].id == value) {
                    storeData.otherPageData.data.splice(index, 1);
                    this.list = storeData.otherPageData.data;
                  }
                }
                // this.externalTotalRecord = storeData.otherPageData.pagination.total
              }
              //storeData.key = this.storageKey;
              //this.$store.dispatch("set", storeData);
            }
            break;
          }
          this.list[index][key] = value;
        }
      }

    },
    externalTotalRecord() {
    },
    force(val){
      this.internalForce = val
    },
    tempPerPage(val){
      this.$emit('perPageFilterChanged')
      this.loading = true
      this.perPage = parseInt(val)
      this.currentPage = 1
      this.list = []
      this.sendCall()
    },
    filteredData(val){
      this.currentPage = 1
      this.list = []
      this.sendCall()
    }
  }
};
</script>
<style>
.hiddenRow {
  padding: 0 !important;
}
</style>

